/* Original enhancements; Horizon remains the single owner of cart mutations. */
document.documentElement.classList.add('dtc-js');

class DtcComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.addEventListener('input', event => {
      if (event.target instanceof HTMLInputElement) {
        this.style.setProperty('--position', `${Math.min(100, Math.max(0, Number(event.target.value)))}%`);
      }
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('dtc-comparison-slider')) customElements.define('dtc-comparison-slider', DtcComparisonSlider);

class DtcCardScroller extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.addEventListener('pointerdown', this.startDrag, { signal });
    this.addEventListener('pointermove', this.drag, { signal });
    this.addEventListener('pointerup', this.stopDrag, { signal });
    this.addEventListener('pointercancel', this.stopDrag, { signal });
    this.addEventListener('lostpointercapture', this.stopDrag, { signal });
    this.addEventListener('click', event => {
      if (this.didDrag) event.preventDefault();
    }, { capture: true, signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
  startDrag = event => {
    if (this.scrollWidth <= this.clientWidth) return;
    this.dragging = true;
    this.didDrag = false;
    this.startX = event.clientX;
    this.startScrollLeft = this.scrollLeft;
    this.setPointerCapture(event.pointerId);
    this.toggleAttribute('data-dragging', true);
  };
  drag = event => {
    if (!this.dragging) return;
    const distance = event.clientX - this.startX;
    if (Math.abs(distance) > 4) this.didDrag = true;
    this.scrollLeft = this.startScrollLeft - distance;
  };
  stopDrag = () => {
    this.dragging = false;
    this.removeAttribute('data-dragging');
    requestAnimationFrame(() => { this.didDrag = false; });
  };
}
if (!customElements.get('dtc-card-scroller')) customElements.define('dtc-card-scroller', DtcCardScroller);

const enableReviewScroller = root => {
  root.querySelectorAll('.dtc-review-grid').forEach(scroller => {
    if (scroller.dataset.dragReady) return;
    scroller.dataset.dragReady = 'true';
    let dragging = false;
    let didDrag = false;
    let startX = 0;
    let startScrollLeft = 0;
    scroller.addEventListener('pointerdown', event => {
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      dragging = true;
      didDrag = false;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
      scroller.setPointerCapture(event.pointerId);
      scroller.toggleAttribute('data-dragging', true);
    });
    scroller.addEventListener('pointermove', event => {
      if (!dragging) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 4) didDrag = true;
      scroller.scrollLeft = startScrollLeft - distance;
    });
    const stopDrag = () => {
      dragging = false;
      scroller.removeAttribute('data-dragging');
      requestAnimationFrame(() => { didDrag = false; });
    };
    scroller.addEventListener('pointerup', stopDrag);
    scroller.addEventListener('pointercancel', stopDrag);
    scroller.addEventListener('lostpointercapture', stopDrag);
    scroller.addEventListener('click', event => {
      if (didDrag) event.preventDefault();
    }, true);
    const reviewCount = scroller.querySelectorAll('.dtc-review').length;
    if (reviewCount > 3 && !scroller.nextElementSibling?.classList.contains('dtc-review-nav')) {
      const navigation = document.createElement('div');
      navigation.className = 'dtc-review-nav';
      navigation.setAttribute('aria-label', 'Bläddra bland recensioner');
      navigation.innerHTML = '<button type="button" aria-label="Föregående recensioner">←</button><button type="button" aria-label="Nästa recensioner">→</button>';
      const [previous, next] = navigation.querySelectorAll('button');
      const move = direction => scroller.scrollBy({ left: direction * (scroller.clientWidth + 20), behavior: 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      scroller.after(navigation);
    }
  });
};
enableReviewScroller(document);
document.addEventListener('shopify:section:load', event => enableReviewScroller(event.target));

class DtcTicker extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.querySelector('button')?.addEventListener('click', event => {
      const paused = this.toggleAttribute('data-paused');
      event.currentTarget.setAttribute('aria-pressed', String(paused));
      event.currentTarget.textContent = paused ? '▶' : 'Ⅱ';
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('dtc-ticker')) customElements.define('dtc-ticker', DtcTicker);
